const APIS = {
  getBannerImgList:['jeecg-boot/gst/bannerImages/list', 'GET'],//轮播地址
  getArticleList:['jeecg-boot/articleSet/articleSet/list','GET'],//公告列表 新闻列表
  getArticleDetails:['jeecg-boot/articleSet/articleSet/queryById','GET'],//公告详情 新闻详情 
  getGroupList:['jeecg-boot/gst/userGroup/queryGroupList','GET'],//获取分类 
  getGoodsList:['jeecg-boot/gst/goodsRelease/list','GET'],//推荐产品 
  getGoodsDetails:['jeecg-boot/gst/goodsRelease/queryById','GET'],//推荐产品 
  getOtherList:['jeecg-boot/gst/goodsRelease/quesyGoods','POST'],//其它产品 
  getOfferList:['jeecg-boot/gst/demand/list','POST'],//资源列表 
  getOfferDetails:['jeecg-boot/gst/demandInfo/queryById','GET'],//资源详情
  getOfferAdd:['jeecg-boot/gst/procurementOffer/add','POST'],//供应商提交报价
  getDynamicsList:['jeecg-boot/gst/schangqing/list','POST'],//药材交易动态
  getSCGroupList:['jeecg-boot/gst/schangqing/getGroupList','POST'],//市场交易动态 字母分组
  
  getQueryCount:['jeecg-boot/gst/demand/queryCount','POST'],//推荐资源 报价条数

  // 首页推荐资源
  getDemandInfoList:['jeecg-boot/gst/demandInfo/list','GET'],//首页推荐资源

  getSearchList:['jeecg-boot/gst/goodsRelease/list','GET'],//首页搜索接口 
  
  getCode:['jeecg-boot/gst/userAccount/sendCode','GET'], //验证码
  getLogin:['jeecg-boot/gst/userAccount/login','POST'],// 登录
  getRegister:['jeecg-boot/gst/userAccount/add','POST'],//注册

  

}
const getApi = api => {
  return APIS[api] && APIS[api]
}

export default getApi



// WEBPACK FOOTER //
// ./src/api/api.js